<template>
  <div id="app">
    <img src="../../assets/christmasPC-2019/banner.png" class="banner" />
    <div class="content">
      <div class="topTitle">
        <img src="../../assets/christmasPC-2019/snowflake-blue.png" />
        <span>Christmas Discounts</span>
      </div>
      <ul>
        <li
          v-for="(item, index) in memberList"
          :key="index"
          class="memberItem item"
          :class="{'choosed': currentIndex == index}"
          @click="currentIndex=index"
        >
          <div class="leftPay">
            <div>
              {{item.sale}}
              <p>OFF</p>
            </div>
          </div>
          <div class="rightPay">
            <p>{{item.title}}</p>
            <p>
              {{item.valueSymbol}}{{item.valuePrice}}/{{item.init}}
              <span>{{item.oldValue}}</span>
            </p>
            <div class="btn" @click="toBuy(memberList[currentIndex],'page_tab_buy','discount')">
              <img :src="item.logo" />
              Buy Now
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="wrapper">
      <div class="rightShow">
        <ul class="rightListWrapper">
          <li
            v-for="(item, index) in rightList[currentIndex]"
            :key="index"
            class="rightList-page"
            @click="toBuy(memberList[currentIndex],'page_Equity', 'discount')"
          >
            <div v-for="(ele, i) in item" :key="i">
              <div class="rightBG">
                <img :src="ele.rightImg" />
              </div>
              <p>{{ele.rightTitle}}</p>
              <p>{{ele.rightDec}}</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="solidList"></div>
      <div class="rightIcon" @click="toBuy(memberList[currentIndex],'page_Equity', 'discount')">
        <img :src="memberList[currentIndex].saleImg" />
      </div>
    </div>
    <ul class="talkWrapper">
      <li
        v-for="(item, index) in evaluateList"
        :key="index"
        class="talkItem item"
        @click="toBuy(memberList[index],'page_evaluate', 'discount')"
      >
        <div class="talkTop">
          <img :src="item.logoImg" />
          <div>
            <p>User Reviews</p>
            <p>{{item.title}}</p>
          </div>
        </div>
        <div class="showTalk">
          <ul class="talk-content-box" :class="item.key">
            <li class="talkContent" v-for="(ele, i) in item.userList" :key="i">
              <div class="box">
                <img :src="ele.userImg" class="userImg" />
                <p>{{ele.userName}}</p>
                <p class="talk">{{ele.talk}}</p>
                <div
                  class="btn"
                  @click.stop="toBuy(memberList[index],'page_evaluate_buy', 'discount')"
                >Want to buy</div>
              </div>
            </li>
          </ul>
          <img
            src="../../assets/christmasPC-2019/left.png"
            class="directionBtn left"
            @click.stop="changeTalk('left',index)"
          />
          <img
            src="../../assets/christmasPC-2019/right.png"
            class="directionBtn right"
            @click.stop="changeTalk('right',index)"
          />
        </div>
      </li>
    </ul>
    <div class="footer">
      <img src="../../assets/christmasPC-2019/foot.png" class="footerImg" />
      <div class="footerWrapper">
        <div class="topTitle">
          <img src="../../assets/christmasPC-2019/snowflake-white.png" />
          <span>Christmas Coupons</span>
        </div>
        <ul>
          <li
            v-for="(item, index) in couponList"
            :key="index"
            class="couponItem item"
            :class="{'gray': (item.dateAvailabe==1) || (item.countAvailabe==1)}"
          >
            <div class="leftPay">
              <p>{{item.sale}} OFF</p>
              <p>{{item.title}}</p>
              <p>
                {{item.valueSymbol}}{{item.valuePrice}}/{{item.init}}
                <span>{{item.oldValue}}</span>
              </p>
            </div>
            <div class="rightPay">
              <div
                class="btn gray"
                v-if="(item.dateAvailabe==1) || (item.countAvailabe==1)"
                @click="noCoupon"
              >Use Now</div>
              <div
                class="btn"
                @click="toBuy(couponList[index],'page_coupon_use','coupon' )"
                v-else
              >Use Now</div>
              <p>Validity: {{item.expireDate}}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Loading ref="loading"></Loading>
    <canclePay @PayDetainment="PayDetainment" v-show="cancelToast"></canclePay>
  </div>
</template>
<script>
import $ from "jquery";
import Loading from "./components/Loading";
import canclePay from "./components/canclePay";
import InlineCart from "./plugins/inlineCart.js";
import Url from "./plugins/link.js";
let Timer = null;
let moving = false;
let success = false;
let upRecordNum = 0;
export default {
  name: "app",
  components: {
    Loading,
    canclePay
  },
  data() {
    return {
      cancelToast: false,
      inlineCart: null,
      couponList: [
        {
          sale: "40%",
          title: "WPS Premium",
          valueSymbol: "$",
          valuePrice: "17.99",
          init: "Year",
          oldValue: "29.99",
          expireDate: "2020-01-01",
          activityId: 83,
          logo: require("../../assets/christmasPC-2019/premium-mini.png"),
          PricingConfigurationCode: "WPS_SUBSCRIPTION_40OFF",
          saveMoney: 12,
          dateAvailabe: 0,
          countAvailabe: 0,
          typeName: "premium",
          sku: "2015"
        },
        {
          sale: "30%",
          title: "PDF Toolkit",
          valueSymbol: "$",
          valuePrice: "13.99",
          init: "Year",
          oldValue: "19.99",
          expireDate: "2020-01-01",
          activityId: 86,
          logo: require("../../assets/christmasPC-2019/pdf-mini.png"),
          PricingConfigurationCode: "PDF_SUBSCRIPTION_30OFF",
          saveMoney: 6,
          dateAvailabe: 0,
          countAvailabe: 0,
          typeName: "pdf",
          sku: "2016"
        },
        {
          sale: "65%",
          title: "Template Premium",
          valueSymbol: "$",
          valuePrice: "27.99",
          init: "Year",
          oldValue: "79.99",
          expireDate: "2020-01-01",
          activityId: 88,
          logo: require("../../assets/christmasPC-2019/template-mini.png"),
          PricingConfigurationCode: "TEMPLATE_SUBSCRIPTION_V12_65OFF",
          saveMoney: 52,
          dateAvailabe: 0,
          countAvailabe: 0,
          typeName: "template",
          sku: "2012"
        }
      ],
      memberList: [
        {
          sale: "40%",
          title: "WPS Premium",
          valueSymbol: "$",
          valuePrice: "17.99",
          init: "Year",
          oldValue: "29.99",
          logo: require("../../assets/christmasPC-2019/premium-mini.png"),
          saleImg: require("../../assets/christmasPC-2019/sale12.png"),
          sku: "2015",
          PricingConfigurationCode: "WPS_SUBSCRIPTION_40OFF",
          typeName: "premium"
        },
        {
          sale: "30%",
          title: "PDF Toolkit",
          valueSymbol: "$",
          valuePrice: "13.99",
          init: "Year",
          oldValue: "19.99",
          logo: require("../../assets/christmasPC-2019/pdf-mini.png"),
          saleImg: require("../../assets/christmasPC-2019/sale6.png"),
          sku: "2016",
          PricingConfigurationCode: "PDF_SUBSCRIPTION_30OFF",
          typeName: "pdf"
        },
        {
          sale: "65%",
          title: "Template Premium",
          valueSymbol: "$",
          valuePrice: "27.99",
          init: "Year",
          oldValue: "79.99",
          logo: require("../../assets/christmasPC-2019/template-mini.png"),
          saleImg: require("../../assets/christmasPC-2019/sale52.png"),
          sku: "2012",
          PricingConfigurationCode: "TEMPLATE_SUBSCRIPTION_V12_65OFF",
          typeName: "template"
        }
      ],
      evaluateList: [
        {
          logoImg: require("../../assets/christmasPC-2019/premium.png"),
          title: "WPS Premium",
          key: "wps",
          userList: [
            {
              userImg: require("../../assets/christmasPC-2019/Anna.png"),
              userName: "Anna",
              talk: `"I think I'm in love with this productivity app，It is a very god app to use when you are taking notes and sometimes doing work."`
            },
            {
              userImg: require("../../assets/christmasPC-2019/DanielChen.png"),
              userName: "Daniel",
              talk: `"Cross platform products, available in Win、Linux and Mac. Couldn't be happier. This product deserves more praise."`
            },
            {
              userImg: require("../../assets/christmasPC-2019/Edward.png"),
              userName: "Edward",
              talk: `"Found by comparing with many products，It's easy to use and much lighter than IPages  or MS Office."`
            },
            {
              userImg: require("../../assets/christmasPC-2019/Anna.png"),
              userName: "Anna",
              talk: `"I think I'm in love with this productivity app，It is a very god app to use when you are taking notes and sometimes doing work."`
            }
          ]
        },
        {
          logoImg: require("../../assets/christmasPC-2019/pdf.png"),
          title: "PDF Toolkit",
          key: "pdf",
          userList: [
            {
              userImg: require("../../assets/christmasPC-2019/Kimberly.png"),
              userName: "Kimberly",
              talk: `"I've used this app on my phone before but never realized you can put it on your computer. No need to ever buy the other office app again."`
            },
            {
              userImg: require("../../assets/christmasPC-2019/Laura.png"),
              userName: "Laura",
              talk: `"WPS office is a very valuable office software. Now Google play and App store can download it. very easy to use."`
            },
            {
              userImg: require("../../assets/christmasPC-2019/Ronald.png"),
              userName: "Ronald",
              talk: `"Good. I like it very much. It can help me improve the efficiency of business, and WPS Premium is very cheap, If you don't believe it, please try it."`
            },
            {
              userImg: require("../../assets/christmasPC-2019/Kimberly.png"),
              userName: "Kimberly",
              talk: `"I've used this app on my phone before but never realized you can put it on your computer. No need to ever buy the other office app again."`
            }
          ]
        },
        {
          logoImg: require("../../assets/christmasPC-2019/template.png"),
          title: "Template Premium",
          key: "template",
          userList: [
            {
              userImg: require("../../assets/christmasPC-2019/Ruchika.png"),
              userName: "Ruchika",
              talk: `"This app is recommended by my friend. I bought a premium, including office suite, PDF toolkit and many templates. one app solves a lot of needs."`
            },
            {
              userImg: require("../../assets/christmasPC-2019/Scott.png"),
              userName: "Scott",
              talk: `"I'll tell you that WPS office is a necessary suite for excellent work efficiency. It can work well on windows, MAC and Android."`
            },
            {
              userImg: require("../../assets/christmasPC-2019/Vikas.png"),
              userName: "Vikas",
              talk: `"Bought during Thanksgiving promotion，have used it a half day，Totally meet my needs. if you do not upgrade premium，can also use it free."`
            },
            {
              userImg: require("../../assets/christmasPC-2019/Ruchika.png"),
              userName: "Ruchika",
              talk: `"This app is recommended by my friend. I bought a premium, including office suite, PDF toolkit and many templates. one app solves a lot of needs."`
            }
          ]
        }
      ],
      rightList: [
        [
          [
            {
              rightTitle: "All-in-one Office",
              rightDec:
                "Get all the benefits of Premium services on both Android and PC.",
              rightImg: require("../../assets/christmasPC-2019/premium/all-in-one.png")
            },
            {
              rightTitle: "PDF Tools",
              rightDec:
                "Tools for converting PDF to doc or long pictures, adding annotations and watermarks, etc.",
              rightImg: require("../../assets/christmasPC-2019/premium/PDF-tools.png")
            },
            {
              rightTitle: "Open Office",
              rightDec:
                "Documents, spreadsheets, presentations, PDF, all standard functions are used casually, without downloading separately.",
              rightImg: require("../../assets/christmasPC-2019/premium/open-Office.png")
            },
            {
              rightTitle: "Recognize Text",
              rightDec:
                "Identify the text in the image and output the document for easy editing without having to purchase it separately.",
              rightImg: require("../../assets/christmasPC-2019/premium/recognize-Text.png")
            },
            {
              rightTitle: "File Compressor",
              rightDec:
                "Compress document size, take up less space and enhanced transmission speed.",
              rightImg: require("../../assets/christmasPC-2019/premium/file-compress.png")
            },
            {
              rightTitle: "No Ads",
              rightDec:
                "Buy WPS Premium, with enhanced function, clean page and no advertisement.",
              rightImg: require("../../assets/christmasPC-2019/premium/no-ads.png")
            }
          ],
          [
            {
              rightTitle: "Bookmark Sharing",
              rightDec:
                "Convert text to exquisite bookmarks，and easily share with friends.",
              rightImg: require("../../assets/christmasPC-2019/premium/bookmark-sharing.png")
            },
            {
              rightTitle: "Document Recover",
              rightDec:
                "Easily recover deleted documents within 7days as you wish.",
              rightImg: require("../../assets/christmasPC-2019/premium/document-recovery.png")
            },
            {
              rightTitle: "Extract Pages",
              rightDec:
                "Pick a specified page to form a new PDF document, leaving only the needed content.",
              rightImg: require("../../assets/christmasPC-2019/premium/extract-pages.png")
            },
            {
              rightTitle: "Watermark",
              rightDec:
                "Support to add watermarks and remove watermarks in PDF documents to meet the needs.",
              rightImg: require("../../assets/christmasPC-2019/premium/watermark.png")
            },
            {
              rightTitle: "20G Cloud Space",
              rightDec:
                "Members can get 20G large cloud storage space, multi-end storage, simultaneous viewing.",
              rightImg: require("../../assets/christmasPC-2019/premium/20Gcloud-space.png")
            },
            {
              rightTitle: "Merge Documents",
              rightDec:
                "Combine multiple documents into a new document for easy record, nice view and summary.",
              rightImg: require("../../assets/christmasPC-2019/premium/merge-documents.png")
            }
          ],
          [
            {
              rightTitle: "Reading Background",
              rightDec:
                "Be able to choose a variety of reading backgrounds to create a comfortable and personalized reading atmosphere.",
              rightImg: require("../../assets/christmasPC-2019/premium/reading-background.png")
            },
            {
              rightTitle: "Picture to PDF",
              rightDec:
                "Picture to PDF for information sharing and long-term storage.",
              rightImg: require("../../assets/christmasPC-2019/premium/picture-to-PDF.png")
            },
            {
              rightTitle: "Long Storage Backup",
              rightDec:
                "90-days long backup storage, documents deleted in 7 days can be quickly retrieved.",
              rightImg: require("../../assets/christmasPC-2019/premium/extract-pages.png")
            },
            {
              rightTitle: "VIP Identity",
              rightDec:
                "Display the WPS Premium VIP logo to highlight your membership and make your show more personal.",
              rightImg: require("../../assets/christmasPC-2019/premium/VIP-identity.png")
            }
          ],
          [
            {
              rightTitle: "All-in-one Office",
              rightDec:
                "Get all the benefits of Premium services on both Android and PC.",
              rightImg: require("../../assets/christmasPC-2019/premium/all-in-one.png")
            },
            {
              rightTitle: "PDF Tools",
              rightDec:
                "Tools for converting PDF to doc or long pictures, adding annotations and watermarks, etc.",
              rightImg: require("../../assets/christmasPC-2019/premium/PDF-tools.png")
            },
            {
              rightTitle: "Open Office",
              rightDec:
                "Documents, spreadsheets, presentations, PDF, all standard functions are used casually, without downloading separately.",
              rightImg: require("../../assets/christmasPC-2019/premium/open-Office.png")
            },
            {
              rightTitle: "Recognize Text",
              rightDec:
                "Identify the text in the image and output the document for easy editing without having to purchase it separately.",
              rightImg: require("../../assets/christmasPC-2019/premium/recognize-Text.png")
            },
            {
              rightTitle: "File Compressor",
              rightDec:
                "Compress document size, take up less space and enhanced transmission speed.",
              rightImg: require("../../assets/christmasPC-2019/premium/file-compress.png")
            },
            {
              rightTitle: "No Ads",
              rightDec:
                "Buy WPS Premium, with enhanced function, clean page and no advertisement.",
              rightImg: require("../../assets/christmasPC-2019/premium/no-ads.png")
            }
          ]
        ],
        [
          [
            {
              rightTitle: "PDF to Word",
              rightDec:
                "Freely copy and edit document content after converting PDF to Word document.",
              rightImg: require("../../assets/christmasPC-2019/pdf/PDF-to-Word.png")
            },
            {
              rightTitle: "PDF to Excel",
              rightDec:
                "Freely copy and edit document content after converting PDF to Excel document.",
              rightImg: require("../../assets/christmasPC-2019/pdf/PDF-to-excel.png")
            },
            {
              rightTitle: "PDF to PPT",
              rightDec:
                "Freely copy and edit document content after converting PDF to PPT document.",
              rightImg: require("../../assets/christmasPC-2019/pdf/PDF-to-PPT.png")
            },
            {
              rightTitle: "PDF Signature",
              rightDec:
                "Easily add a personal signature on the pdf, providing initial signature, date signature.",
              rightImg: require("../../assets/christmasPC-2019/pdf/PDF-signature.png")
            },
            {
              rightTitle: "PDF Merge",
              rightDec:
                "Combine multiple PDF documents into a new PDF document for easy recording, viewing, summary.",
              rightImg: require("../../assets/christmasPC-2019/pdf/PDF-merge.png")
            },
            {
              rightTitle: "PDF Annotation",
              rightDec:
                "Free paintbrush marking, cover pen, shapes and stamps are available, support for inserting text PDF.",
              rightImg: require("../../assets/christmasPC-2019/pdf/PDF-annotation.png")
            }
          ],
          [
            {
              rightTitle: "PDF Watermark",
              rightDec:
                "Add custom watermarks in PDF documents，delete all watermarks in PDF documents.",
              rightImg: require("../../assets/christmasPC-2019/pdf/pdf-watemark.png")
            },
            {
              rightTitle: "PDF File Compressor",
              rightDec:
                "Documents are smaller, more space efficient and faster.",
              rightImg: require("../../assets/christmasPC-2019/pdf/pdf-file-compress.png")
            },
            {
              rightTitle: "PDF Extract",
              rightDec:
                "Select designated pages to form a new PDF document, focus on simplicity, just keep the required content to improve efficiency.",
              rightImg: require("../../assets/christmasPC-2019/pdf/PDFextract.png")
            },
            {
              rightTitle: "Web to PDF",
              rightDec:
                "To convert web page to PDF，click on the browser: Share>More> Webpage to PDF.",
              rightImg: require("../../assets/christmasPC-2019/pdf/web-to-pdf.png")
            },
            {
              rightTitle: "Add Text",
              rightDec:
                "Free paintbrush marking, cover pen, shapes and stamps are available, support for inserting text in PDF.",
              rightImg: require("../../assets/christmasPC-2019/pdf/Add-Text.png")
            },
            {
              rightTitle: "Page Adjustment",
              rightDec:
                "Easily change the page order of PDF Documents, add blank pages and delete specific pages.",
              rightImg: require("../../assets/christmasPC-2019/pdf/Page-Adjustment.png")
            }
          ],
          [
            {
              rightTitle: "Picture Sharing",
              rightDec:
                "Divers formats for your choice，make the long picture more beautiful，more personalized，more easily to share.",
              rightImg: require("../../assets/christmasPC-2019/premium/picture-share.png")
            },
            {
              rightTitle: "Backup Center Storage",
              rightDec: "60-days long backup storage.",
              rightImg: require("../../assets/christmasPC-2019/pdf/back-center-storage-60.png")
            },
            {
              rightTitle: "VIP Identity",
              rightDec:
                "Display the PDF Toolkit VIP logo to highlight your membership and make your show more personal.",
              rightImg: require("../../assets/christmasPC-2019/premium/VIP-identity.png")
            }
          ],
          [
            {
              rightTitle: "PDF to Word",
              rightDec:
                "Freely copy and edit document content after converting PDF to Word document.",
              rightImg: require("../../assets/christmasPC-2019/pdf/PDF-to-Word.png")
            },
            {
              rightTitle: "PDF to Excel",
              rightDec:
                "Freely copy and edit document content after converting PDF to Excel document.",
              rightImg: require("../../assets/christmasPC-2019/pdf/PDF-to-excel.png")
            },
            {
              rightTitle: "PDF to PPT",
              rightDec:
                "Freely copy and edit document content after converting PDF to PPT document.",
              rightImg: require("../../assets/christmasPC-2019/pdf/PDF-to-PPT.png")
            },
            {
              rightTitle: "PDF Signature",
              rightDec:
                "Easily add a personal signature on the pdf, providing initial signature, date signature.",
              rightImg: require("../../assets/christmasPC-2019/pdf/PDF-signature.png")
            },
            {
              rightTitle: "PDF Merge",
              rightDec:
                "Combine multiple PDF documents into a new PDF document for easy recording, viewing, summary.",
              rightImg: require("../../assets/christmasPC-2019/pdf/PDF-merge.png")
            },
            {
              rightTitle: "PDF Annotation",
              rightDec:
                "Free paintbrush marking, cover pen, shapes and stamps are available, support for inserting text PDF.",
              rightImg: require("../../assets/christmasPC-2019/pdf/PDF-annotation.png")
            }
          ]
        ],
        [
          [
            {
              rightTitle: "Cross-Platform Office suite",
              rightDec:
                "Enjoy a privilege on the PC, Android, and IOS for one purchase.",
              rightImg: require("../../assets/christmasPC-2019/template/cross-platform-office-suite.png")
            },
            {
              rightTitle: "Full access to free Templates",
              rightDec:
                "Template Premium user can use all free templates and paid templates.",
              rightImg: require("../../assets/christmasPC-2019/template/Full-accsess-to-free-template.png")
            },
            {
              rightTitle: "Unlimited downloads of Template",
              rightDec:
                "Template Premium user can use all free templates and paid templates.",
              rightImg: require("../../assets/christmasPC-2019/template/Unlimited-download.png")
            },
            {
              rightTitle: "1000+ assets, fonts, infographics, and more",
              rightDec:
                "More than 1,000 assets, fonts, infographics, etc. cover work and study.",
              rightImg: require("../../assets/christmasPC-2019/template/100.png")
            },
            {
              rightTitle: "Cloud Storage",
              rightDec:
                "1G cloud storage space, dedicated to template use, enough space.",
              rightImg: require("../../assets/christmasPC-2019/template/1gb-cloud-storage.png")
            },
            {
              rightTitle: "Backup Center Storage",
              rightDec: "60-days long backup storage.",
              rightImg: require("../../assets/christmasPC-2019/template/back-center-storage-90.png")
            }
          ],
          [
            {
              rightTitle: "No Ads",
              rightDec:
                "Buy Template Premium, with enhanced function, clean page and without advertisement.",
              rightImg: require("../../assets/christmasPC-2019/premium/no-ads.png")
            },
            {
              rightTitle: "VIP Identity",
              rightDec:
                "Display the Template Premium VIP logo to highlight your membership and make your show more personal.",
              rightImg: require("../../assets/christmasPC-2019/premium/VIP-identity.png")
            }
          ],
          [
            {
              rightTitle: "Cross-Platform Office suite",
              rightDec:
                "Enjoy a privilege on the PC, Android, and IOS for one purchase.",
              rightImg: require("../../assets/christmasPC-2019/template/cross-platform-office-suite.png")
            },
            {
              rightTitle: "Full access to free Templates",
              rightDec:
                "Template Premium user can use all free templates and paid templates.",
              rightImg: require("../../assets/christmasPC-2019/template/Full-accsess-to-free-template.png")
            },
            {
              rightTitle: "Unlimited downloads of Template",
              rightDec:
                "Template Premium user can use all free templates and paid templates.",
              rightImg: require("../../assets/christmasPC-2019/template/Unlimited-download.png")
            },
            {
              rightTitle: "1000+ assets, fonts, infographics, and more",
              rightDec:
                "More than 1,000 assets, fonts, infographics, etc. cover work and study.",
              rightImg: require("../../assets/christmasPC-2019/template/100.png")
            },
            {
              rightTitle: "Cloud Storage",
              rightDec:
                "1G cloud storage space, dedicated to template use, enough space.",
              rightImg: require("../../assets/christmasPC-2019/template/1gb-cloud-storage.png")
            },
            {
              rightTitle: "Backup Center Storage",
              rightDec: "60-days long backup storage.",
              rightImg: require("../../assets/christmasPC-2019/template/back-center-storage-90.png")
            }
          ]
        ]
      ],
      currentIndex: 0,
      showIndex: 0,
      LastPayGoods: {},
      checkUser: false
    };
  },
  methods: {
    PayDetainment(action) {
      upRecordNum = 0;
      this.cancelToast = false;
      let item = this.LastPayGoods.item ? this.LastPayGoods.item : null;
      let type = this.LastPayGoods.type ? this.LastPayGoods.type : null;
      let element = "";
      if (action == "continue") {
        if (item && type) {
          this.purchasePremium(item, type);
        }
        element = "page_detainment_continue";
      } else if (action == "cancle") {
        element = "page_detainment_abandon";
      }
      this.$api.sendDw(
        "pc_page",
        element,
        "click",
        "[" + this.source + "][" + type + "]",
        item.typeName,
        item.sku
      );
    },
    noCoupon() {
      this.$toast.show("Not enough coupons.");
    },
    changeTab() {
      let that = this;
      $(".memberItem").hover(function() {
        let nowCurrent = $(this).index();
        if (that.currentIndex == nowCurrent) return;
        that.currentIndex = nowCurrent;
        clearTimeout(Timer);
        that.initPage();
        $(".rightListWrapper").css({
          left: 0
        });
        that.changeSpan("", 0);
        Timer = setTimeout(that.autoMove, 3000);
      });
      that.initPage();
      clearTimeout(Timer);
      Timer = setTimeout(this.autoMove, 3000);
    },
    autoMove() {
      let len = this.rightList[this.currentIndex].length;
      let changUL = $(".rightListWrapper");
      let moveWidth = $(".rightShow")
        .eq(0)
        .width();
      clearTimeout(Timer);
      this.moveAnimation("left", changUL, len, moveWidth);
      this.changeSpan("left");
      Timer = setTimeout(this.autoMove, 3000);
    },
    changeSpan(direction, index) {
      let changeIndex = this.showIndex;
      if (typeof index == "number") {
        changeIndex = index;
      } else {
        if (direction == "left") {
          changeIndex++;
        } else if (direction == "right") {
          changeIndex--;
        }
        if (changeIndex < 0) {
          changeIndex = this.rightList[this.currentIndex].length - 2;
        } else if (
          changeIndex >=
          this.rightList[this.currentIndex].length - 1
        ) {
          changeIndex = 0;
        }
      }
      this.showIndex = changeIndex;
      $(".solidList")
        .find("span")
        .removeClass();
      $(".solidList")
        .find("span")
        .eq(changeIndex)
        .addClass("active");
    },
    changeTalk(direction, index) {
      if (moving) return;
      moving = true;
      setTimeout(() => {
        moving = false;
      }, 400);
      let changUL = $(`.${this.evaluateList[index].key}`);
      let len = this.evaluateList[index].userList.length;
      let animationWidth = $(".talkContent")
        .eq(0)
        .width();
      this.moveAnimation(direction, changUL, len, animationWidth);
    },
    moveAnimation(direction, changUL, len, animationWidth) {
      let nowLeft = parseInt(changUL.css("left"));
      let left = 0;
      switch (direction) {
        case "left":
          left = nowLeft - animationWidth;
          if (left < -(len - 1) * animationWidth) {
            left = -animationWidth;
            changUL.css({
              left: 0
            });
          }
          changUL.animate({
            left: left
          });
          break;
        case "right":
          left = nowLeft + animationWidth;
          if (left > 0) {
            left = -animationWidth * (len - 2);
            changUL.css({
              left: -animationWidth * (len - 1)
            });
          }
          changUL.animate({
            left: left
          });
          break;
        default:
          break;
      }
    },
    // 初始化轮播图ul的宽度
    initPage() {
      let that = this;
      let len = this.rightList[this.currentIndex].length;
      let insertSpan = "";
      let contentWidth = $(".rightShow")
        .eq(0)
        .width();
      $(".rightListWrapper").width(contentWidth * len);
      $(".solidList").empty();
      for (var i = 0; i < len - 1; i++) {
        let oSpan = "<span></span>";
        insertSpan += oSpan;
      }
      $(".solidList").append(insertSpan);
      $(".solidList")
        .find("span")
        .eq(this.showIndex)
        .addClass("active");
      $(".solidList")
        .find("span")
        .on("click", function() {
          if (that.showIndex == $(this).index()) return;
          clearInterval(Timer);
          that.showIndex = $(this).index();
          $(".rightListWrapper").css({
            left: -contentWidth * that.showIndex
          });
          that.changeSpan("", $(this).index());
          clearTimeout(Timer);
          Timer = setTimeout(that.autoMove, 3000);
        });
    },
    // 购买会员
    purchasePremium: function(item, type) {
      let skuId = "";
      let src = type;
      if (type == "coupon") {
        skuId = item.skus[0].sku;
      } else {
        skuId = item.sku;
      }
      if (!skuId) return;
      if (this.loading) {
        return;
      }
      this.LastPayGoods = {
        item,
        type
      };
      this.loading = true;
      this.$refs.loading.show();
      // 支付流程---
      // 订单参数
      let orderParams = {
        source: src,
        productId: Number(skuId),
        productName: "WPS Premium"
      };

      // 购物车参数
      let cartParams = {
        productCode: item.PricingConfigurationCode,
        saleSource: src
      };
      try {
        this.purchaseing(orderParams, cartParams, item, type);
      } catch (err) {
        this.loading = false;
        this.$refs.loading.hide();
      }
    },
    // 正在购买中...
    purchaseing: async function(orderParams, cartParams, item, type) {
      try {
        // 创建订单
        let orderData = await this.$api.createOrder(orderParams);
        if (orderData.code === 0 && orderData.links.length > 0) {
          let subParams = {
            order_id: orderData.order_id,
            subscribe_url: orderData.links[0].href
          };
          let subRes = await this.$api.subscription(subParams);
          if (subRes && subRes.code === 0) {
            // 隐藏loading
            this.$refs.loading.hide();
            // 加入购物车购买
            let coCartParams = Object.assign(cartParams, {
              orderId: orderData.order_id,
              customerId: orderData.order_db_id
            });
            if (this.inlineCart) {
              // 先移除之前下单商品
              this.inlineCart.removeAllProduct();
              // 添加商品
              this.inlineCart.startCheckout({
                params: coCartParams,
                closed: response => {
                  this.loading = false;
                  if (!success) {
                    this.cancelToast = true;
                  }
                  let products = window.TwoCoInlineCart.products.getAll();
                  let product = products[0];
                  upRecordNum++;
                  if (upRecordNum <= 1) {
                    // 关闭支付打点
                    this.$api.sendDw(
                      "pc_page",
                      "page_detainment",
                      "show",
                      "[" + this.source + "][" + type + "]",
                      item.typeName,
                      orderParams.productId
                    );
                    this.$api.sendDw(
                      "pc_purchase",
                      "purchase",
                      "close",
                      "[" + this.source + "][" + type + "]",
                      item.typeName,
                      orderParams.productId
                    );
                  }
                },
                finalized: () => {
                  // 获取当前支付成功的商品,请求更新优惠码
                  let products = window.TwoCoInlineCart.products.getAll();
                  let product = products[0];
                  if (product.code === "WPS_SUBSCRIPTION_40OFF") {
                    this.isWPS = 1;
                    if (type == "coupon") {
                      this.updateCoupon(
                        this.couponList[0],
                        coCartParams.orderId
                      );
                    }
                  } else if (product.code === "PDF_SUBSCRIPTION_30OFF") {
                    this.isPDF = 1;
                    if (type == "coupon") {
                      this.updateCoupon(
                        this.couponList[1],
                        coCartParams.orderId
                      );
                    }
                  } else if (
                    product.code === "TEMPLATE_SUBSCRIPTION_V12_65OFF"
                  ) {
                    this.isTPL = 1;
                    if (type == "coupon") {
                      this.updateCoupon(
                        this.couponList[2],
                        coCartParams.orderId
                      );
                    }
                  }
                  this.$toast.show(
                    "Subscription success！Log in to your WPS account on P.C or Mobile device and enjoy member privileges."
                  );
                  success = true;
                  this.loading = false;
                  // 支付成功打点
                  this.$api.sendDw(
                    "pc_purchase",
                    "purchase",
                    "success",
                    "[" + this.source + "][" + type + "]",
                    item.typeName,
                    orderParams.productId
                  );
                }
              });
              // 展示支付弹窗打点
              this.$api.sendDw(
                "pc_purchase",
                "purchase",
                "show",
                "[" + this.source + "][" + type + "]",
                item.typeName,
                orderParams.productId
              );
            }
          }
        } else {
          this.loading = false;
          this.$refs.loading.hide();
        }
      } catch (err) {
        this.loading = false;
        this.$refs.loading.hide();
      }
    },
    // 消耗优惠券
    updateCoupon: function(item, orderId) {
      let paySku = item.skus[0].sku;
      let params = {
        promo_code: item.promoCode,
        order_id: orderId,
        pay_sku: paySku,
        platform: "pc"
      };
      this.$api
        .usedCode(params)
        .then(res => {
          if (res.code === 0) {
            // 更新码状态
            item.status = "used";
            item.tag = "Used";
          }
        })
        .catch(err => {});
    },
    ifUse(item) {
      if (
        (item.typeName === "premium" && this.isWPS) ||
        (item.typeName === "pdf" && this.isPDF) ||
        (item.typeName === "template" && this.isTPL)
      ) {
        this.$toast.show("Already subscribed, do not subscribe again.");
        return true;
      } else {
        return false;
      }
    },
    // 根据活动ID获取当前用户的优惠码详情
    userActivityCoupon: function(item) {
      return new Promise((resolve, reject) => {
        let params = {
          activity_id: item.activityId,
          platform: "pc"
        };
        this.$api.getActivityCoupon(params).then(res => {
          if (res.code === 0) {
            let coupon = res.data;
            // 10 未使用（已绑定；不包括已过期）；11 已使用；12 已过期；
            if (coupon.promo_code_status === 11) {
              item.status = "used";
            } else if (coupon.promo_code_status === 12) {
              item.status = "expired";
            } else if (coupon.promo_code_status === 10) {
              item.status = "geted";
            }
            item.skus = coupon.skus;
            item.promoCode = coupon.promo_code;
          } else if (res.code === 106) {
            // 当前用户没有该活动的优惠码；
            item.status = "unget";
          }
          resolve(item);
        });
      });
    },
    sendCoupon: function(item) {
      // 请求发放优惠码
      let params = {
        platform: "pc",
        activity_id: item.activityId
      };
      this.$api
        .codedeLivery(params)
        .then(res => {
          if (res.code === 0 && res.data) {
            // 用户获得优惠券
            item.status = "geted";
            item.promoCode = res.data.promo_code;
            item.skus = res.data.skus;
            this.$toast.show("Get Coupon Successfully!");
            // 领取成功打点
            this.$api.sendDw(
              "pc_page",
              "page_coupon_sent_success",
              "success",
              "[" + this.source + "][coupon]",
              item.typeName,
              item.skus[0].sku
            );
          } else {
            // 已抢光
            if (res.code === 101) {
              item.status = "expired";
              this.$toast.show("Not enough coupons.");
            } else {
              this.$toast.show("Get failed, please try again later.");
            }
            // 领取失败打点
            this.$api.sendDw(
              "pc_page",
              "page_coupon_sent_fail",
              "fail",
              "[" + this.source + "][coupon]",
              item.typeName,
              item.sku
            );
          }
        })
        .catch(err => {
          this.$toast.show("Get failed, please try again later.");
          this.$api.sendDw(
            "pc_page",
            "page_coupon_sent_fail",
            "fail",
            "[" + this.source + "][coupon]",
            item.typeName,
            item.sku
          );
        });
    },
    upRecord(item, position, type) {
      let sku =
        type == "discount" ? item.sku : item.skus ? item.skus[0].sku : item.sku;
      this.$api.sendDw(
        "pc_page",
        position,
        "click",
        "[" + this.source + "][" + type + "]",
        item.typeName,
        sku
      );
    },
    toBuy: async function(item, position, type) {
      this.upRecord(item, position, type);
      if (!this.user) {
        let login = await this.$weblogin.open();
        this.$api.sendDw(
          "pc_login",
          "login_board",
          "show",
          "[" + this.source + "][" + type + "]",
          item.typeName,
          item.sku
        );
        let curUser = await this.$api.getUser200();
        if (curUser && curUser.result !== "userNotLogin") {
          this.$api.sendDw(
            "pc_login",
            "login_board",
            "success",
            "[" + this.source + "][" + type + "]",
            item.typeName,
            item.sku
          );
          this.user = curUser;
        }
        this.checkUserVip();
        this.checkmember(item, position, type);
      } else {
        this.checkmember(item, position, type);
      }
    },
    checkmember(item, position, type) {
      if (!this.checkUser) {
        setTimeout(() => {
          this.checkmember(item, position, type);
        }, 300);
      } else {
        if (this.ifUse(item)) return;
        if (type == "coupon") {
          this.buynow(item, position, type);
        } else {
          this.purchasePremium(item, type);
        }
      }
    },
    buynow: async function(item, position, type) {
      await this.userActivityCoupon(item);
      if (item.status === "unget") {
        try {
          await this.sendCoupon(item);
          // 不是实时更新数据
          setTimeout(() => {
            this.purchasePremium(item, type);
          }, 1000);
        } catch (error) {
          this.$toast.show("Buy failure");
        }
      } else if (item.status === "geted") {
        this.purchasePremium(item, type);
      } else if (item.status === "used") {
        this.$toast.show("Already subscribed, do not subscribe again.");
      } else if (item.status === "expired") {
        this.$toast.show("Already expired");
      }
    },
    checkUserVip(item, position) {
      this.$api.checkVip().then(res => {
        if (res.code === 0) {
          let data = res.data;
          if (data.length > 0) {
            let currentTime = Math.round(new Date() / 1000);
            for (let i = 0; i < data.length; i++) {
              if (
                data[i].service_id === 210 &&
                data[i].expire_time > currentTime
              ) {
                // 会员
                this.isWPS = 1;
              } else if (
                data[i].service_id === 4699612 &&
                data[i].expire_time > currentTime
              ) {
                // PDF
                this.isPDF = 1;
              } else if (
                data[i].service_id === 5 &&
                data[i].expire_time > currentTime
              ) {
                // 模板
                this.isTPL = 1;
              }
            }
          }
          this.checkUser = true;
          console.log("会员身份", this.isWPS, this.isPDF, this.isTPL);
        }
      });
    },
    // 获取活动的有效性-按钮置灰
    activityValidity: function() {
      let idstr = `${this.couponList[0].activityId},${this.couponList[1].activityId},${this.couponList[2].activityId}`;
      let params = {
        ids: idstr
      };
      this.$api.activityValidity(params).then(res => {
        if (res.code === 0 && res.data) {
          let arr = res.data;
          arr.forEach(el => {
            for (let i = 0; i < this.couponList.length; i++) {
              if (this.couponList[i].activityId === el.activity_id) {
                this.couponList[i].dateAvailabe = el.date_available;
                // 优惠码已过期
                this.couponList[i].countAvailabe = el.date_available;
                // 优惠码已领取完
              }
            }
          });
        }
      });
    },
    // 客户端弹窗跳转支付页
    clientPay: async function() {
      let payItem = "";
      switch (this.couponType) {
        case "wps":
          payItem = this.couponList[0];
          break;
        case "pdf":
          payItem = this.couponList[1];
          break;
        case "template":
          payItem = this.couponList[2];
          break;
        default:
          break;
      }
      let curUser = await this.$api.getUser200();
      if (payItem) {
        this.toBuy(payItem, "page_coupon_use", "coupon");
      }
    },
    getUrlKey: function(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    checkLogin: async function() {
      try {
        let curUser = await this.$api.getUser200();
        if (curUser && curUser.result !== "userNotLogin") {
          this.user = curUser;
          this.checkUserVip();
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  created() {
    this.source = this.getUrlKey("source");
    this.activityValidity();
    this.checkLogin();
    this.couponType = this.getUrlKey("couponType");
    let autoPay = window.sessionStorage.getItem('autoPay');
    if (this.couponType && !autoPay) {
      window.sessionStorage.setItem('autoPay', 1);
      this.clientPay();
    }
  },
  mounted() {
    this.inlineCart = InlineCart;
    // 监听网络
    window.addEventListener(
      "offline",
      () => {
        this.$toast.show("No Internet connection.");
      },
      false
    );
    this.changeTab();
    this.$api.sendDw("pc_page", "pc_page", "show", this.source);
  }
};
</script>

<style lang="less">
ul,
li,
p {
  margin: 0;
  padding: 0;
}
#app {
  min-width: 1280px;
}
li {
  list-style: none;
  display: inline-block;
  width: 374px;
}
.item {
  width: 374px;
  margin-right: 39px;
  &:last-child {
    margin-right: 0px;
  }
}
.banner,
.footerImg {
  width: 100%;
  vertical-align: top;
}
.footerImg {
  height: 536px;
}
.content {
  width: 1200px;
  margin: -32px auto 0;
}
.rightShow {
  width: 1200px;
  height: 599px;
  margin: 0 auto 63px;
  overflow: hidden;
  background: #ea3131;
  position: relative;
  cursor: pointer;
  ul {
    width: 300%;
    height: 100%;
    position: absolute;
    left: 0px;
    li {
      width: 1200px;
      height: 599px;
      padding: 38px 45px 61px;
      box-sizing: border-box;
      vertical-align: top;
      div:nth-child(4) {
        margin-top: 40px;
      }
      div:nth-child(5) {
        margin-top: 40px;
      }
      div:nth-child(6) {
        margin-top: 40px;
      }
    }
  }
}
.solidList {
  position: absolute;
  bottom: 31px;
  left: 50%;
  transform: translateX(-50%);
  span {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 19px;
    background: #fff;
    cursor: pointer;
    &:last-child {
      margin-right: 0px;
    }
  }
  span.active {
    background: #ffe100;
  }
}
.wrapper {
  width: 1200px;
  height: 599px;
  margin: 0 auto 63px;
  position: relative;
}
.rightIcon {
  background: url("../../assets/christmasPC-2019/Star-3.png");
  width: 128px;
  height: 128px;
  position: absolute;
  right: -43px;
  bottom: -45px;
  color: rgba(234, 49, 49, 1);
  font-family: HiraKakuStdN-W8, HiraKakuStdN;
  text-align: center;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
    animation: move 3s ease forwards infinite;
  }
}
.rightList-page > div {
  width: 33.33%;
  display: inline-block;
  height: 50%;
  color: rgba(255, 255, 255, 1);
  vertical-align: top;
  p {
    font-size: 18px;
    font-family: Arial-BoldMT, Arial;
    line-height: 21px;
    width: 311px;
    margin: 0 auto 10px;
    text-align: center;
  }
  p:last-child {
    font-size: 14px;
    font-family: ArialMT;
    line-height: 20px;
    text-align: left;
    width: 311px;
    height: 60px;
  }
}
.rightBG {
  background: url("../../assets/christmasPC-2019/rightIntro-BG.png");
  width: 134px;
  height: 134px;
  margin: 0px auto;
  position: relative;
  img {
    position: absolute;
    width: 40px;
    height: 40px;
    top: 41px;
    left: 50%;
    transform: translateX(-50%);
  }
}
.topTitle {
  font-size: 30px;
  font-family: Arial-BoldMT, Arial;
  font-weight: normal;
  color: rgba(0, 0, 0, 1);
  line-height: 64px;
  margin-bottom: 45px;
  img {
    width: 57px;
    height: 64px;
    margin-right: 25px;
    vertical-align: middle;
  }
}
.memberItem {
  height: 160px;
  background: #ff5959;
  padding: 25px 0px 23px 31px;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  .leftPay {
    width: 112px;
    height: 112px;
    background: url("../../assets/christmasPC-2019/Star-1.png");
    font-size: 28px;
    font-family: HiraKakuStdN-W8, HiraKakuStdN;
    line-height: 42px;
    position: relative;
    margin-right: 29px;
    div {
      width: 100%;
      position: absolute;
      top: 50%;
      text-align: center;
      transform: translateY(-50%);
    }
    p {
      font-size: 16px;
      line-height: 24px;
      margin-top: -6px;
    }
  }
  .rightPay {
    font-family: Arial-BoldMT, Arial;
    p:first-child {
      font-size: 18px;
      line-height: 18px;
      margin-bottom: 11px;
    }
    p:nth-child(2) {
      font-size: 21px;
      line-height: 24px;
      margin-bottom: 14px;
    }
    p:nth-child(2) span {
      font-size: 14px;
      font-family: ArialMT;
      line-height: 16px;
      margin-left: 8px;
      text-decoration: line-through;
    }
    .btn {
      width: 156px;
      height: 39px;
      line-height: 39px;
      text-align: center;
      background: rgba(255, 225, 0, 1);
      border-radius: 21px;
      font-size: 18px;
      font-family: Arial-BoldMT, Arial;
      color: rgba(87, 48, 0, 1);
      position: relative;
      cursor: pointer;
    }
    .btn img {
      width: 24px;
      height: 26px;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
.memberItem > div,
.couponItem > div {
  display: inline-block;
  vertical-align: top;
}
.memberItem.choosed {
  background: #ea3131;
  .leftPay {
    background-image: url("../../assets/christmasPC-2019/Star-2.png");
  }
}
.footerWrapper {
  color: #fff;
  width: 1200px;
  margin: -358px auto 0;
  .topTitle span {
    color: #fff;
  }
  .couponItem {
    height: 141px;
    background-image: url("../../assets/christmasPC-2019/coupon.png");
    background-size: 100%;
    background-repeat: no-repeat;
    padding: 31px 0px 29px 21px;
    box-sizing: border-box;
    vertical-align: top;
  }
  .couponItem.gray {
    background-image: url("../../assets/christmasPC-2019/couponGray.png");
  }
  .leftPay p {
    font-size: 24px;
    font-family: Arial-BoldMT, Arial;
    color: rgba(255, 255, 255, 1);
    line-height: 24px;
    &:first-child {
      font-family: HiraKakuStdN-W8, HiraKakuStdN;
    }
    &:nth-child(2) {
      font-size: 18px;
      line-height: 21px;
      margin-top: 12px;
    }
    &:last-child {
      font-size: 16px;
      line-height: 18px;
      margin-top: 8px;
      span {
        font-size: 14px;
        font-family: ArialMT;
        line-height: 16px;
        margin-left: 7px;
        text-decoration: line-through;
      }
    }
  }
  .rightPay {
    font-family: ArialMT;
    float: right;
    width: 133px;
    text-align: center;
    .btn {
      width: 89px;
      height: 34px;
      line-height: 34px;
      background: rgba(255, 155, 40, 1);
      border-radius: 17px;
      font-size: 14px;
      margin: 0px auto 24px;
      cursor: pointer;
    }
    .btn.gray {
      background: #d1d1d1;
    }
    p {
      font-size: 12px;
      color: rgba(184, 184, 184, 1);
      line-height: 14px;
    }
  }
}
.talkWrapper {
  width: 1200px;
  margin: 18px auto 0px;
  cursor: pointer;
  .talkTop {
    display: flex;
    align-items: center;
    color: rgba(0, 0, 0, 1);
    img {
      width: 64px;
      height: 72px;
      margin-right: 25px;
    }
    p:first-child {
      font-size: 20px;
      font-family: ArialMT;
      line-height: 23px;
    }
    p:last-child {
      font-size: 24px;
      font-family: Arial-BoldMT, Arial;
      line-height: 28px;
      margin-top: 7px;
    }
  }
  .showTalk {
    width: 374px;
    overflow: hidden;
    margin-top: 29px;
    height: 394px;
    position: relative;
    ul {
      width: 1496px;
      position: absolute;
    }
  }
  .talkItem:first-child .showTalk {
    background: #ff9b28;
  }
  .talkItem:last-child .showTalk {
    background: #8d23e7;
  }
  .talkItem:nth-child(2) .showTalk {
    background: #ff3b44;
  }
}
.directionBtn {
  width: 18px;
  height: 50px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.directionBtn.left {
  left: 0px;
}
.directionBtn.right {
  right: 0px;
}
.talkContent {
  position: relative;
  .box {
    width: 293px;
    padding: 40px 0px 38px;
    box-sizing: border-box;
    margin: 0 auto;
    text-align: center;
    color: #fff;
    .userImg {
      width: 72px;
      height: 72px;
      border-radius: 50%;
      margin-bottom: 33px;
    }
    p {
      font-size: 16px;
      font-family: Arial-BoldMT, Arial;
      line-height: 18px;
    }
    .talk {
      font-size: 14px;
      font-family: ArialMT;
      line-height: 20px;
      height: 80px;
      margin: 23px 0px 31px;
      text-align: left;
    }
    .btn {
      width: 264px;
      height: 60px;
      background: rgba(255, 225, 0, 1);
      border-radius: 30px;
      font-size: 22px;
      font-family: Arial-BoldMT, Arial;
      color: rgba(87, 48, 0, 1);
      line-height: 60px;
      margin: 0 auto;
      position: relative;
      overflow: hidden;
    }
  }
}
@keyframes move {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/christmasPC-2019/App.vue